module.exports = __webpack_public_path__ + "static/img/ck2.f44be53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/ck2.png
// module id = 308
// module chunks = 0